import { render } from "./WalletPay.vue?vue&type=template&id=09dc1ea4&scoped=true"
import script from "./WalletPay.vue?vue&type=script&lang=js"
export * from "./WalletPay.vue?vue&type=script&lang=js"

import "./WalletPay.vue?vue&type=style&index=0&id=09dc1ea4&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09dc1ea4"]])

export default __exports__